import { render, staticRenderFns } from "./SendDocumentsPersonal.vue?vue&type=template&id=bf8093d0&scoped=true&"
import script from "./SendDocumentsPersonal.vue?vue&type=script&lang=ts&"
export * from "./SendDocumentsPersonal.vue?vue&type=script&lang=ts&"
import style0 from "./SendDocumentsPersonal.vue?vue&type=style&index=0&id=bf8093d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8093d0",
  null
  
)

export default component.exports